import React, { Component } from 'react';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button, { BUTTON_STYLE } from '../../../shared-components/Button/Button';
import { REDIRECT_SUFFIX } from '../../../framework/App/AppConstants';
import { redirectFlowAction } from '../../../framework/store/RedirectFlow/RedirectFlowActions';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen } from '../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import './CancelUrl.less';
import _ from 'lodash';

const LOCALE_PREFIX = 'DE/components/Footer/Footer';

export const COMPONENT_STYLE = {
    LINK_BUTTON: 'LINK_BUTTON', // Button underneath call to action buttons (continue, apply)
    FOOTER_LINK: 'FOOTER_LINK'
};

export class CancelUrl extends Component {
    static propTypes = {
        doCancelRedirect: PropTypes.func.isRequired,
        fireFptiEvent: PropTypes.func,

        merchantName: PropTypes.string,
        fptiEvent: PropTypes.shape({ // Convenience prop for FPTI tracking
            stateName: PropTypes.string,
            transitionName: PropTypes.string
        }),
        componentType: PropTypes.oneOf(Object.values(COMPONENT_STYLE)),
        customLabel: PropTypes.string,
        intl: intlShape.isRequired,
        isPayInFullNowAvailable: PropTypes.bool
    };

    handleClick = () => {
        const { doCancelRedirect, fireFptiEvent, fptiEvent, isPayInFullNowAvailable, componentType } = this.props;
        let cancelUri;

        if (componentType === COMPONENT_STYLE.LINK_BUTTON) {
            cancelUri = isPayInFullNowAvailable ? REDIRECT_SUFFIX.PAY_IN_FULL_REDIRECT : REDIRECT_SUFFIX.CANCEL_REDIRECT;
        } else {
            cancelUri = REDIRECT_SUFFIX.CANCEL_REDIRECT;
        }

        if (fptiEvent) {
            fireFptiEvent(fptiEvent.stateName, fptiEvent.transitionName);
        }

        return doCancelRedirect(cancelUri);
    };


    render() {
        const { intl, merchantName, customLabel, componentType } = this.props;

        const label = (customLabel) ? intl.formatMessage({id: customLabel}) :
            intl.formatMessage({id: `${LOCALE_PREFIX}.cancelApplicationWithMerchant`}, {merchantName});
        
        return (
            <div className="CancelUrl link">
                <Button
                    data-automation-id="cancel"
                    btnStyle={BUTTON_STYLE.LINK}
                    onClick={this.handleClick}
                >{label}</Button>
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    merchantName: state.serverData.merchantName,
    isPayInFullNowAvailable: _.get(state, 'serverData.isPayInFullNowAvailable')
});

export const mapDispatchToProps = dispatch => ({
    doCancelRedirect(actionUri) {
        dispatch(spinnerOpen());
        dispatch(redirectFlowAction(actionUri));
    },
    fireFptiEvent(stateName, transitionName) {
        dispatch(trackTransition(stateName, transitionName));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CancelUrl));
